module.exports = "/_next/static/images/3739e560d77a49649d9c4ae13e7b9f92-challenge-the-system-xs@1x.jpg";